import { Phone, Mail, MapPin, Globe } from "lucide-react";

const LINKS = [
  { label: "Servicios", href: "#servicios" },
  { label: "Visa Americana", href: "#visa" },
  { label: "Productos", href: "#productos" },
  { label: "Nosotros", href: "#nosotros" },
  { label: "Contacto", href: "#contacto" },
];

const SERVICES = [
  "Impresión de Documentos",
  "Impresión de Planos",
  "Fotocopias",
  "Escaneo Digital",
  "Asesoría Visa DS-160",
  "Accesorios Electrónicos",
];

export default function Footer() {
  return (
    <footer className="bg-[#111111] text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">

          {/* Brand */}
          <div className="lg:col-span-1">
            <img
              src="/images/logo.png"
              alt="Printacce Logo"
              className="h-12 w-auto rounded-xl mb-4"
            />
            <p className="text-gray-400 text-sm leading-relaxed mb-5">
              Tu centro de impresión, asesoría de Visa Americana y accesorios electrónicos
              en Altamira, Managua.
            </p>
            <div className="flex gap-3">
              <a
                href="https://wa.me/50589984547"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-whatsapp-link"
                className="bg-[#25D366] hover:opacity-90 text-white rounded-full p-2.5 transition-opacity"
                aria-label="WhatsApp"
              >
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
                </svg>
              </a>
              <a
                href="mailto:printacce@gmail.com"
                data-testid="footer-email-link"
                className="bg-[#E65B78] hover:bg-[#D44B66] text-white rounded-full p-2.5 transition-colors"
                aria-label="Correo"
              >
                <Mail size={16} />
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-sm font-bold text-white uppercase tracking-wider mb-4">Navegación</h4>
            <ul className="flex flex-col gap-2.5">
              {LINKS.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-gray-400 hover:text-[#E65B78] text-sm font-medium transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-sm font-bold text-white uppercase tracking-wider mb-4">Servicios</h4>
            <ul className="flex flex-col gap-2.5">
              {SERVICES.map((s) => (
                <li key={s}>
                  <span className="text-gray-400 text-sm font-medium">{s}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-bold text-white uppercase tracking-wider mb-4">Contacto</h4>
            <div className="flex flex-col gap-4">
              <a href="tel:+50589984547" className="flex items-start gap-3 group">
                <Phone size={15} className="text-[#E65B78] mt-0.5 flex-shrink-0" />
                <span className="text-gray-400 text-sm group-hover:text-[#E65B78] transition-colors">8998 4547</span>
              </a>
              <a href="mailto:printacce@gmail.com" className="flex items-start gap-3 group">
                <Mail size={15} className="text-[#E65B78] mt-0.5 flex-shrink-0" />
                <span className="text-gray-400 text-sm group-hover:text-[#E65B78] transition-colors">printacce@gmail.com</span>
              </a>
              <div className="flex items-start gap-3">
                <MapPin size={15} className="text-[#E65B78] mt-0.5 flex-shrink-0" />
                <span className="text-gray-400 text-sm">Entrada UCC, 1/2 c. arriba y 1/2 abajo, casa 93. Altamira, Managua</span>
              </div>
              <div className="flex items-start gap-3">
                <Globe size={15} className="text-[#E65B78] mt-0.5 flex-shrink-0" />
                <a
                  href="http://printacce.online.com.ni"
                  className="text-gray-400 text-sm hover:text-[#E65B78] transition-colors"
                >
                  printacce.online.com.ni
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-white/10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-gray-500 text-sm text-center">
            2025 Printacce – Impresiones y Accesorios. Todos los derechos reservados.
          </p>
          <p className="text-gray-500 text-xs">
            Managua, Nicaragua
          </p>
        </div>
      </div>
    </footer>
  );
}
